"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Auth = _interopRequireDefault(require("composer-lib/data/model/Auth"));

var _Categories = _interopRequireDefault(require("ContentUtils/constants/Categories"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _NavTabs = _interopRequireDefault(require("ComposeUI/components/NavTabs"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _RevisionsButtonContainer = _interopRequireDefault(require("composer-lib/containers/composer/RevisionsButtonContainer"));

var _SaveButtonContainer = _interopRequireDefault(require("composer-lib/containers/composer/SaveButtonContainer"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _SaveStatusContainer = _interopRequireDefault(require("composer-lib/containers/composer/SaveStatusContainer"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIToolBar = _interopRequireDefault(require("UIComponents/nav/UIToolBar"));

var _UIToolBarGroup = _interopRequireDefault(require("UIComponents/nav/UIToolBarGroup"));

var _UserSettings = _interopRequireDefault(require("ComposeUI/data/model/UserSettings"));

var _usageTracker = require("../lib/usageTracker");

var langKey = function langKey(key) {
  return "ComposeUI.header." + key;
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save,
    users: state.users
  };
};

var HeaderContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HeaderContainer, _Component);

  function HeaderContainer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, HeaderContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(HeaderContainer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleBackLinkClick = function () {
      _usageTracker.usageTrackerAsBeacon.track('compositionInteraction', {
        action: 'back-link-clicked'
      });
    };

    _this.handleContinueClick = function () {
      var _this$props = _this.props,
          composition = _this$props.composition,
          openComposeEditInterstitialModal = _this$props.openComposeEditInterstitialModal;

      if (composition.isReadOnly()) {
        window.location.href = _Routes.default.edit(composition.getIn(['data', 'originId']), _Categories.default.blog_post.field_name);
      } else {
        openComposeEditInterstitialModal();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(HeaderContainer, [{
    key: "renderBackLink",
    value: function renderBackLink() {
      var _this$props2 = this.props,
          composition = _this$props2.composition,
          getBackLink = _this$props2.getBackLink;
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        size: "extra-small",
        href: getBackLink(composition),
        className: "back-link",
        onClick: this.handleBackLinkClick
      }, _react.default.createElement(_UIIcon.default, {
        name: "left"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: langKey('back')
      }));
    }
  }, {
    key: "renderContinueButton",
    value: function renderContinueButton() {
      var _this$props3 = this.props,
          auth = _this$props3.auth,
          lock = _this$props3.lock,
          saveState = _this$props3.saveState;
      var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
      var badScope = !auth.user.get('scopes').find(function (s) {
        return s === 'blog-write';
      });
      return _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
        disabled: locked || badScope,
        onClick: this.handleContinueClick,
        size: "small",
        use: "primary"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: langKey('next')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          composition = _this$props4.composition,
          userId = _this$props4.userId,
          userSettings = _this$props4.userSettings;
      return _react.default.createElement(_UIToolBar.default, {
        className: "header-container"
      }, _react.default.createElement(_UIToolBarGroup.default, null, this.renderBackLink()), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_NavTabs.default, {
        blogPostId: composition.getIn(['data', 'originId']),
        showReadOnlyMode: composition.isReadOnly(),
        userId: userId,
        userSettings: userSettings
      })), _react.default.createElement(_UIToolBarGroup.default, null, _react.default.createElement(_SaveStatusContainer.default, null), _react.default.createElement(_SaveButtonContainer.default, null), _react.default.createElement(_RevisionsButtonContainer.default, null), this.renderContinueButton()));
    }
  }]);
  return HeaderContainer;
}(_react.Component);

HeaderContainer.propTypes = {
  auth: _propTypes.default.instanceOf(_Auth.default).isRequired,
  composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
  getBackLink: _propTypes.default.func,
  lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
  openComposeEditInterstitialModal: _propTypes.default.func.isRequired,
  saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
  userId: _propTypes.default.number,
  userSettings: _propTypes.default.instanceOf(_UserSettings.default).isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(HeaderContainer);

exports.default = _default;
module.exports = exports.default;